import { ACTION_LOGOUT } from "app/modules/login/reducer/actions.type";
import {
  FETCH_TERM_DEPOSIT_LIST_TOP_UP_REQUEST,
  FETCH_TERM_DEPOSIT_LIST_TOP_UP_SUCCESS,
  FETCH_TERM_DEPOSIT_LIST_TOP_UP_FAILURE,
  FETCH_TERM_DEPOSIT_TOP_UP_CREATE_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_CREATE_SUCCESS,
  FETCH_TERM_DEPOSIT_TOP_UP_CREATE_FAILURE,
  FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_SUCCESS,
  FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_FAILURE,
  FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_FAILURE,
  SET_TERM_TOP_UP_STORE,
  SET_TERM_TOP_UP_RESET,
} from "./actions.type";

import { TermDepositTopUpState, TermDepositTopUpActions } from "./types";

const initialState: TermDepositTopUpState = {
  pending: false,
  responseList: undefined,
  dataCreate: undefined,
  responseCreate: undefined,
  responseConfirm: undefined,
  responseAuth: undefined,
  isCreated: false,
  isConfirm: false,
  isAuthorization: false,
  errorOTP: false,
  statusCreate: "init",
  statusConfirm: "init",
  statusAuth: "init",
  errorMsg: undefined,
};

export default (state = initialState, action: TermDepositTopUpActions): TermDepositTopUpState => {
  switch (action.type) {
    case FETCH_TERM_DEPOSIT_LIST_TOP_UP_REQUEST:
      return {
        ...state,
        pending: true,
        responseList: undefined,
        errorMsg: undefined,
      };
    case FETCH_TERM_DEPOSIT_LIST_TOP_UP_SUCCESS:
      return {
        ...state,
        pending: false,
        responseList: action.payload,
      };
    case FETCH_TERM_DEPOSIT_LIST_TOP_UP_FAILURE:
      return {
        ...state,
        pending: false,
        errorMsg: action.payload,
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_CREATE_REQUEST:
      return {
        ...state,
        pending: true,
        isCreated: false,
        dataCreate: action.payload,
        responseCreate: undefined,
        statusCreate: "pending",
        errorMsg: undefined,
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_CREATE_SUCCESS:
      return {
        ...state,
        pending: false,
        isCreated: true,
        responseCreate: action.payload,
        statusCreate: "ok",
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_CREATE_FAILURE:
      return {
        ...state,
        pending: false,
        statusCreate: "error",
        errorMsg: action.payload,
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_REQUEST:
      return {
        ...state,
        pending: true,
        isConfirm: false,
        responseConfirm: undefined,
        errorOTP: false,
        statusConfirm: "pending",
        errorMsg: undefined,
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_SUCCESS:
      return {
        ...state,
        pending: false,
        isConfirm: true,
        responseConfirm: action.payload,
        statusConfirm: "ok",
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_FAILURE:
      return {
        ...state,
        pending: false,
        statusConfirm: "error",
        errorMsg: action.payload,
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_REQUEST:
      return {
        ...state,
        pending: true,
        isAuthorization: false,
        responseAuth: undefined,
        statusAuth: "pending",
        errorMsg: undefined,
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_SUCCESS:
      return {
        ...state,
        pending: false,
        isAuthorization: true,
        responseAuth: action.payload,
        statusAuth: "ok",
      };
    case FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_FAILURE:
      return {
        ...state,
        pending: false,
        errorOTP: action.payload,
        statusAuth: "error",
        errorMsg: action.msg,
      };
    case SET_TERM_TOP_UP_STORE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_TERM_TOP_UP_RESET:
      return {
        ...initialState,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
